(function () {
  const getVisibleSlides = (type, slideCount) => {
    const width = window.innerWidth;
    if (type === 'products') {
      if (width >= 990) {
        if (slideCount <= 4) return Math.min(3, slideCount);
        return Math.min(4, slideCount);
      }
      if (width >= 750) return Math.min(2, slideCount);
      return 1;
    }
    return 1;
  };

  const getGap = () => (window.innerWidth >= 750 ? 24 : 16);

  const initSlider = (root) => {
    if (root.dataset.jjSliderReady === 'true') return;
    const type = root.dataset.jjSliderType || 'full';
    const track = root.querySelector('[data-jj-slider-track]');
    const slides = Array.from(root.querySelectorAll('[data-jj-slide]'));
    const prev = root.querySelector('[data-jj-slider-prev]');
    const next = root.querySelector('[data-jj-slider-next]');
    const dotsWrap = root.querySelector('[data-jj-slider-dots]');
    const controls = root.querySelector('.jj-home-products__controls, .jj-luxe-slider__controls');
    if (!track || slides.length === 0) return;

    root.dataset.jjSliderReady = 'true';

    let index = 0;
    let visible = 1;
    let dots = [];
    let timer;
    const autoplay = root.dataset.autoplay === 'true';
    const speed = parseInt(root.dataset.speed, 10) || 5000;

    const maxIndex = () => Math.max(0, slides.length - visible);

    const getStep = () => {
      const slide = slides[0];
      if (!slide) return 0;
      return slide.getBoundingClientRect().width + getGap();
    };

    const toggleControls = () => {
      if (!controls) return;
      const canScroll = type === 'products' ? slides.length > visible : slides.length > 1;
      controls.hidden = !canScroll;
    };

    const rebuildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      const total = type === 'products' ? maxIndex() + 1 : slides.length;
      if (total <= 1) return;

      for (let i = 0; i < total; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = type === 'products' ? 'jj-home-products__dot' : 'jj-luxe-slider__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => go(i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    };

    const update = () => {
      if (type === 'products') {
        const step = getStep();
        track.style.transform = step > 0 ? `translate3d(-${index * step}px, 0, 0)` : 'none';
      } else {
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      }

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    };

    const go = (nextIndex) => {
      index = Math.min(Math.max(nextIndex, 0), maxIndex());
      update();
    };

    const applyLayout = () => {
      visible = getVisibleSlides(type, slides.length);
      if (type === 'products') {
        const gap = getGap();
        track.style.gap = `${gap}px`;
        const basis = `calc((100% - ${(visible - 1) * gap}px) / ${visible})`;
        slides.forEach((slide) => {
          slide.style.flex = `0 0 ${basis}`;
        });
      }
      if (index > maxIndex()) index = maxIndex();
      rebuildDots();
      update();
      toggleControls();
    };

    const restart = () => {
      clearInterval(timer);
      if (!autoplay || slides.length <= visible) return;
      timer = setInterval(() => {
        go(index >= maxIndex() ? 0 : index + 1);
      }, speed);
    };

    prev?.addEventListener('click', () => {
      go(index - 1);
      restart();
    });

    next?.addEventListener('click', () => {
      go(index + 1);
      restart();
    });

    let touchStartX = 0;
    let touchDeltaX = 0;

    track.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        touchDeltaX = event.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      () => {
        if (Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) go(index + 1);
        else go(index - 1);
        restart();
      },
      { passive: true }
    );

    const resizeObserver = new ResizeObserver(() => {
      applyLayout();
    });

    const viewport = root.querySelector('[data-jj-slider-viewport]') || root;
    resizeObserver.observe(viewport);

    window.addEventListener('resize', applyLayout);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        applyLayout();
        restart();
      });
    });
  };

  const bootSlider = (slider) => {
    slider.dataset.jjSliderReady = 'false';
    initSlider(slider);
  };

  const initAll = (scope) => {
    const sliders = scope
      ? scope.querySelectorAll('[data-jj-slider]')
      : document.querySelectorAll('[data-jj-slider]');
    sliders.forEach(bootSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
